import { render } from "./DialogueWindow.vue?vue&type=template&id=0c6e64c8"
import script from "./DialogueWindow.vue?vue&type=script&lang=js"
export * from "./DialogueWindow.vue?vue&type=script&lang=js"

import "./DialogueWindow.vue?vue&type=style&index=0&id=0c6e64c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__